import "react-native-reanimated";
import "react-native-gesture-handler";

import * as Sentry from "@sentry/react-native";

import { Slot, useNavigationContainerRef } from "expo-router";
import { persistor, store } from "appRedux/store";

import DesktopOnlyWrapper from "components/DesktopOnlyWrapper";
import ErrorBoundary from "../src/components/ErrorBoundary";
import InitialWrapper from "components/InitialWrapper";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import SEOWrapper from "components/SEOWrapper";
import Toast from "react-native-toast-notifications";
import { isRunningInExpoGo } from "expo";
import { useEffect } from "react";
import { useFonts } from "expo-font";
import { version } from "../package.json";

// Construct a new instrumentation instance. This is needed to communicate between the integration and React
const routingInstrumentation = new Sentry.ReactNavigationInstrumentation();

if (!__DEV__) {
    Sentry.init({
        dsn: "https://035e8260831ac233b614e663fa7d59b4@o4507026806734848.ingest.us.sentry.io/4508255692062720",
        environment: process.env.EXPO_PUBLIC_ENV === "STAGING" ? "development" : "production",
        release: version,
        debug: process.env.EXPO_PUBLIC_ENV === "STAGING" ? true : false, // If `true`, Sentry will try to print out useful debugging information if something goes wrong with sending the event. Set it to `false` in production
        integrations: [
            new Sentry.ReactNativeTracing({
                // Pass instrumentation to be used as `routingInstrumentation`
                routingInstrumentation,
                enableNativeFramesTracking: !isRunningInExpoGo(),
                // ...
            }),
        ],
        tracesSampleRate: 1.0,
    });
}

const RootLayout = () => {
    // Capture the NavigationContainer ref and register it with the instrumentation.
    const refNavContainer = useNavigationContainerRef();
    useEffect(() => {
        if (refNavContainer?.current) {
            routingInstrumentation.registerNavigationContainer(refNavContainer);
        }
    }, [refNavContainer]);

    const [loaded, error] = useFonts({
        JosefinSans: require("../src/assets/fonts/JosefinSans.ttf"),
        LibreBodoni: require("../src/assets/fonts/LibreBodoni.ttf"),
        
    });

    if (!loaded && !error) {
        return <></>;
    }

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <InitialWrapper>
                    <SEOWrapper>
                        <DesktopOnlyWrapper>
                            <ErrorBoundary>
                                <Slot />
                            </ErrorBoundary>
                        </DesktopOnlyWrapper>
                        <Toast ref={(ref) => (global["toast"] = ref)} />
                    </SEOWrapper>
                </InitialWrapper>
            </PersistGate>
        </Provider>
    );
};

// Wrap the Root Layout route component with `Sentry.wrap` to capture gesture info and profiling data.
export default Sentry.wrap(RootLayout);
